module.exports = __webpack_public_path__ + "static/arushi-ec6b2a897bbcc842dfb87d34d180b220.jpg";